import { lazy, memo, Suspense } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import LayoutClient from 'src/layouts/layout';
import SpinnerLoader from 'src/libraries/SpinnerLoader';
import RouteGuard from 'src/routes/guard';
import { Routes as Router } from 'src/routes/route';
import InitAppProvider from './initApp.provider';

const Page404Screen = lazy(() => import('src/screens/errors/page404'));
const Page500Screen = lazy(() => import('src/screens/errors/page500'));
const Page403Screen = lazy(() => import('src/screens/errors/page403'));

const LoginScreen = lazy(() => import('src/screens/auth/login/index'));

const DashboardScreen = lazy(() => import('src/screens/dashboard'));

const NhanVienScreen = lazy(() => import('src/screens/nhanvien'));
const ThemMoiNhanVienScreen = lazy(() => import('src/screens/nhanvien/ThemMoi'));
const ChiTietNhanVienScreen = lazy(() => import('src/screens/nhanvien/ChiTiet'));

const LichLamViecScreen = lazy(() => import('src/screens/LichLamViec'));
const BangCongThangScreen = lazy(() => import('src/screens/BangCongThang'));
const TongHopCongScreen = lazy(() => import('src/screens/TongHopCong'));

const PheDuyetDonNghiPhepScreen = lazy(() => import('src/screens/DonXinNghi/PheDuyet'));
const TongHopPhepNamScreen = lazy(() => import('src/screens/TongHopPhepNam'));

const PhongBanScreen = lazy(() => import('src/screens/phongban'));
const ChucVuScreen = lazy(() => import('src/screens/chucvu'));
const CheDoPhucLoiScreen = lazy(() => import('src/screens/CheDoPhucLoi'));
const CongCuLamViecScreen = lazy(() => import('src/screens/CongCuLamViec'));
const CauHinhChamCongScreen = lazy(() => import('src/screens/CauHinhChamCong'));
const LoaiNghiPhepScreen = lazy(() => import('src/screens/LoaiNghiPhep'));

const TinTucScreen = lazy(() => import('src/screens/TinTuc'));
const ThemMoiTinTucScreen = lazy(() => import('src/screens/TinTuc/ThemMoi'));
const ChinhSuaTinTucScreen = lazy(() => import('src/screens/TinTuc/ChinhSua'));

const BacLuongScreen = lazy(() => import('src/screens/BacLuong'));
const ChiTietBacLuongScreen = lazy(() => import('src/screens/BacLuong/ChiTiet'));

const BangKraScreen = lazy(() => import('src/screens/BangKra'));
const ChiTietBangKraScreen = lazy(() => import('src/screens/BangKra/ChiTiet'));
const KrMucTieuScreen = lazy(() => import('src/screens/KrMucTieu'));
const KrCongViecScreen = lazy(() => import('src/screens/KrCongViec'));
const ChiTietKrCongViecScreen = lazy(() => import('src/screens/KrCongViec/ChiTiet'));

function RouteProvider() {
  return (
    <Routes>
      <Route
        element={
          <InitAppProvider>
            <RouteGuard>
              <LayoutClient />
            </RouteGuard>
          </InitAppProvider>
        }
      >
        <Route path={Router.HOME.path} element={<DashboardScreen />} />

        <Route path={Router.TIN_TUC.path} element={<TinTucScreen />} />
        <Route path={Router.TIN_TUC_THEM_MOI.path} element={<ThemMoiTinTucScreen />} />
        <Route path={`${Router.TIN_TUC_CHINH_SUA.path}/:id`} element={<ChinhSuaTinTucScreen />} />

        <Route path={Router.NHAN_SU.path} element={<NhanVienScreen />} />
        <Route path={Router.NHAN_SU_THEM_MOI.path} element={<ThemMoiNhanVienScreen />} />
        <Route path={`${Router.NHAN_SU.path}/:id`} element={<ChiTietNhanVienScreen />} />

        <Route path={Router.LICH_LAM_VIEC.path} element={<LichLamViecScreen />} />
        <Route path={Router.BANG_CONG_THANG.path} element={<BangCongThangScreen />} />
        <Route path={Router.TONG_HOP_CONG.path} element={<TongHopCongScreen />} />

        <Route path={Router.DON_XIN_NGHI_PHE_DUYET.path} element={<PheDuyetDonNghiPhepScreen />} />
        <Route path={Router.DON_XIN_NGHI_TONG_HOP.path} element={<TongHopPhepNamScreen />} />

        <Route path={Router.CONG_VIEC_BANG_KRA.path} element={<BangKraScreen />} />
        <Route path={`${Router.CONG_VIEC_BANG_KRA.path}/:id`} element={<ChiTietBangKraScreen />} />
        <Route path={Router.CONG_VIEC_KR_MUC_TIEU.path} element={<KrMucTieuScreen />} />
        <Route path={Router.CONG_VIEC_KR_CONG_VIEC.path} element={<KrCongViecScreen />} />
        <Route path={`${Router.CONG_VIEC_KR_CONG_VIEC.path}/:id`} element={<ChiTietKrCongViecScreen />} />

        <Route path={Router.LUONG_BAC_LUONG.path} element={<BacLuongScreen />} />
        <Route path={`${Router.LUONG_BAC_LUONG.path}/:id`} element={<ChiTietBacLuongScreen />} />

        <Route path={Router.CAU_HINH_PHONG_BAN.path} element={<PhongBanScreen />} />
        <Route path={Router.CAU_HINH_CHUC_VU.path} element={<ChucVuScreen />} />
        <Route path={Router.CAU_HINH_CHE_DO_PHUC_LOI.path} element={<CheDoPhucLoiScreen />} />
        <Route path={Router.CAU_HINH_CONG_CU_LAM_VIEC.path} element={<CongCuLamViecScreen />} />
        <Route path={Router.CAU_HINH_CHAM_CONG.path} element={<CauHinhChamCongScreen />} />
        <Route path={Router.CAU_HINH_LOAI_NGHI_PHEP.path} element={<LoaiNghiPhepScreen />} />
      </Route>

      <Route
        element={
          <Suspense fallback={<SpinnerLoader bg={false} />}>
            <Outlet />
          </Suspense>
        }
      >
        <Route path={Router.LOGIN.path} element={<LoginScreen />} />

        <Route path={Router.PAGE500.path} element={<Page500Screen />} />
        <Route path={Router.PAGE403.path} element={<Page403Screen />} />

        <Route path="*" element={<Page404Screen />} />
      </Route>
    </Routes>
  );
}

export default memo(RouteProvider);
